import { TfiltersList, TinitialValues } from "./CallingLineParams.props";

export const parseCron = (cron: string) => {
	const [minutes, hours, date, month, dayOfWeek] = cron.split(" ");
	return { minutes, hours, date, month, dayOfWeek };
};

export const stringifyCron = (obj: any) => {
	return `${obj.minutes ?? "*"} ${obj.hours ?? "*"} ${obj.date ?? "*"} ${obj.month ?? "*"} ${obj.dayOfWeek ?? "*"}`;
};

export const cronToHumanReadable = (cron: string) => {
	const { minutes, hours, date, month, dayOfWeek } = parseCron(cron);

	// Простейшее преобразование, можно улучшить
	const dayStr = dayOfWeek === "*" ? "любого дня" : `день недели ${dayOfWeek}`;
	const monthStr = month === "*" ? "любого месяца" : `месяц ${month}`;
	const dateStr = date === "*" ? "любого числа" : `${date} числа`;

	return `${dateStr}, ${monthStr}, ${dayStr} в ${hours.padStart(2, "0")}:${minutes.padStart(2, "0")}`;
};

export const formatMessage = (message: string) => {
	// Разбиваем по точке с запятой
	const parts = message.split(";");

	return parts
		.map((part) => {
			// Ищем крон-строку (примерно 5 чисел/звёздочек через пробел)
			const cronMatch = part.match(/(\*|\d+)\s+(\*|\d+)\s+(\*|\d+)\s+(\*|\d+)\s+(\*|\d+)/);
			if (cronMatch) {
				return part.replace(cronMatch[0], cronToHumanReadable(cronMatch[0]));
			}
			return part;
		})
		.join(";\n"); // вставляем перенос строки
};

export const FILTERS_LIST: TfiltersList = [
	{ label: "input_listName", title: "name", type: "text", channel: ["telegram", "voice"], size: "1 / -1", required: true },
	{ label: "input_description", title: "description", type: "text", channel: ["telegram", "voice"], size: "1 / -1", required: false },
	{ label: { voice: "input_phoneNumber", telegram: "input_botName" }, title: "source", type: "text", channel: ["telegram", "voice"], size: "0 / 1", required: true },
	{ label: "input_callTries", title: "dialTries", type: "number", channel: ["voice"], size: "0 / 1", required: true },
	{ label: "input_maxChannels", title: "maxChannels", type: "number", channel: ["voice"], size: "0 / 1", required: true },
	{ label: "input_callTimeout", title: "redialTimeout", type: "number", channel: ["voice"], size: "0 / 1", required: true },
	{ label: "input_lineActivityMonitoring", title: "watchdog", type: "number", channel: ["voice"], size: "0 / 1", required: true },
	{ label: "input_noAnswerTimeOut", title: "noAnswerTimeout", type: "number", channel: ["voice"], size: "0 / 1", required: true },
	{ label: "input_trunk", title: "trunk", type: "text", channel: ["voice"], size: "0 / 1", required: true },
	// { label: "input_startTimeOfTheCall", title: "scheduler", type: "time", channel: ["voice"], size: "1 / -1" },
];

export const initialValues: TinitialValues = {
	name: "",
	source: "",
	description: "",
	noAnswerTimeout: 0,
	dialTries: 0,
	maxChannels: 0,
	redialTimeout: 0,
	watchdog: 0,
	autoload: false,
	robotId: "",
	endpointId: "",
	timeintervals: [],
	retryCauses: ["NO_ANSWER", "USER_BUSY", "CALL_REJECTED", "ORIGINATOR_CANCEL"],
	// теперь scheduler — массив cron-объектов
	scheduler: [{ minutes: "*", hours: "*", date: "*", month: "*", dayOfWeek: "*" }],
	isListActiveLocal: false,
	trunk: "",
};

const monthNames = [
	"title_monthShort_jan",
	"title_monthShort_feb",
	"title_monthShort_mar",
	"title_monthShort_apr",
	"title_monthShort_may",
	"title_monthShort_june",
	"title_monthShort_july",
	"title_monthShort_aug",
	"title_monthShort_sept",
	"title_monthShort_oct",
	"title_monthShort_nov",
	"title_monthShort_dec",
];
const dayNames = [
	"title_weekDayShort_mon",
	"title_weekDayShort_tue",
	"title_weekDayShort_wed",
	"title_weekDayShort_thu",
	"title_weekDayShort_fri",
	"title_weekDayShort_sat",
	"title_weekDayShort_sun",
];

export const SCHEDULER_PARAMS = [
	{
		label: "select_dayOfWeek",
		title: "dayOfWeek",
		variantsList: [
			{ title: "*", value: "*" },
			...dayNames.map((name, i) => ({
				title: name,
				value: String(i),
			})),
		],
	},
	{
		label: "select_date",
		title: "date",
		variantsList: [{ title: "*", value: "*" }, ...Array.from({ length: 31 }, (_, i) => ({ title: String(i + 1), value: String(i + 1) }))],
	},
	{
		label: "select_month",
		title: "month",
		variantsList: [
			{ title: "*", value: "*" },
			...monthNames.map((name, i) => ({
				title: name,
				value: String(i + 1),
			})),
		],
	},
	{
		label: "select_hours",
		title: "hours",
		variantsList: [{ title: "*", value: "*" }, ...Array.from({ length: 24 }, (_, i) => ({ title: String(i), value: String(i) }))],
	},
	{
		label: "select_minutes",
		title: "minutes",
		variantsList: [{ title: "*", value: "*" }, ...Array.from({ length: 60 }, (_, i) => ({ title: String(i), value: String(i) }))],
	},
];
